export default "__VITE_ASSET__DFDGkzpA__"